var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModelsLinked = function SvgModelsLinked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5a5.5 5.5 0 1 0 5.02 7.75H5.75a2.25 2.25 0 0 1 0-4.5h4.77A5.5 5.5 0 0 0 5.5 5.5m11 11a5.5 5.5 0 0 1-5.02-3.25h4.77a2.25 2.25 0 0 0 0-4.5h-4.77a5.501 5.501 0 1 1 5.02 7.75M5.75 10a1 1 0 1 0 0 2h10.5a1 1 0 1 0 0-2z"
  })));
};
export default SvgModelsLinked;